import axios from "axios";

const setTokenAllHeaders = async () => {
  const token = localStorage.getItem("adminToken");
  axios.defaults.headers.common["Authorization"] = token;
};

const BASE_URL = process.env.REACT_APP_BASE_URL + "/delivery-app/cancel-reasons";

const list = async ({ limit = 10, page = 0, search = null, reason_type = null, branch_id = null, status = null }) => {
  await setTokenAllHeaders();
  const response = await axios.get(BASE_URL, { params: { limit, page, search, reason_type, branch_id, status } });
  return response.data;
};

const create = async (payload) => {
  await setTokenAllHeaders();
  const response = await axios.post(BASE_URL, payload);
  return response.data;
};

const update = async (id, payload) => {
  await setTokenAllHeaders();
  const response = await axios.post(`${BASE_URL}/${id}`, payload);
  return response.data;
};

const updateStatus = async (id, status) => {
  await setTokenAllHeaders();
  const response = await axios.post(`${BASE_URL}/${id}/status`, { status });
  return response.data;
};

export default { list, create, update, updateStatus };